import { Routes } from '@angular/router';
import { AuthGuard } from '@auth0/auth0-angular';
import { registerGuard } from '@core/guards';
import { userAndGroupGuard } from '@core/guards/user-and-group.guard';
import { AppRoutes } from '@shared/helpers';
import { OrderRetestSetupApi } from './features/orders-retest/orders-retest-setup/_core/api';
import { CkmRetestService } from './features/orders-retest/orders-retest-setup/_core/services';
import { OrderSetupApi } from './features/orders/order-setup/_core/api';

export const appRoutes: Routes = [
    {
        path: 'account/register',
        canActivate: [registerGuard()],
        loadComponent: () =>
            import('./shared/components/general-pages/page-not-found/page-not-found.component').then(
                r => r.PageNotFoundComponent
            ),
    },
    {
        path: ':group',
        canActivate: [AuthGuard],
        children: [
            {
                path: 'error',
                canActivate: [userAndGroupGuard({ canAccessWithNoGroups: true })],
                loadComponent: () =>
                    import('./shared/components/general-pages/error-page/error-page.component').then(
                        r => r.ErrorPageComponent
                    ),
                data: {
                    breadcrumb: null,
                },
            },
            {
                path: 'forbidden-access',
                canActivate: [userAndGroupGuard({ canAccessWithNoGroups: true })],
                loadComponent: () =>
                    import('./shared/components/general-pages/unauthorized-page/unauthorized-page.component').then(
                        r => r.UnauthorizedPageComponent
                    ),
                data: {
                    breadcrumb: null,
                },
            },
            {
                path: 'not-found',
                canActivate: [userAndGroupGuard({ canAccessWithNoGroups: true })],
                loadComponent: () =>
                    import('./shared/components/general-pages/page-not-found/page-not-found.component').then(
                        r => r.PageNotFoundComponent
                    ),
                data: { breadcrumb: null },
            },
            {
                path: AppRoutes.routesSegments.DASHBOARD,
                canActivate: [userAndGroupGuard()],
                loadChildren: () => import('./features/dashboard/dashboard.routes').then(r => r.DashboardRoutes),
                data: {
                    breadcrumb: null,
                },
            },
            {
                path: 'orders',
                canActivate: [userAndGroupGuard()],
                loadChildren: () => import('./features/orders/orders.routes').then(r => r.OrdersRoutes),
                data: {
                    breadcrumb: 'breadcrumb.orderList',
                },
            },
            {
                path: 'checkmate',
                canActivate: [userAndGroupGuard()],
                loadChildren: () =>
                    import('./features/orders-retest/orders-retest.routes').then(r => r.OrdersRetestRoutes),
                data: {
                    breadcrumb: 'breadcrumb.checkMateList',
                },
                providers: [CkmRetestService, OrderSetupApi, OrderRetestSetupApi],
            },
            {
                path: 'inventory',
                canActivate: [userAndGroupGuard()],
                loadChildren: () => import('./features/inventory/inventory.routes').then(r => r.InventoryRoutes),
                data: {
                    breadcrumb: null,
                },
            },
            {
                path: 'groups',
                canActivate: [userAndGroupGuard({ canAccessWithNoGroups: true })],
                loadChildren: () => import('./features/groups/groups.routes').then(r => r.GroupsRoutes),
                data: {
                    breadcrumb: 'breadcrumb.groups',
                },
            },
            {
                path: 'account/clear-cookies',
                canActivate: [userAndGroupGuard({ canAccessWithNoGroups: true })],
                loadComponent: () =>
                    import(
                        './shared/components/general-pages/account-clear-cookies/account-clear-cookies.component'
                    ).then(r => r.AccountClearCookiesComponent),
                data: { breadcrumb: null },
            },
            {
                path: '**',
                canActivate: [userAndGroupGuard({ canAccessWithNoGroups: true })], // the guard also acts as a redirect
                loadComponent: () =>
                    import('./shared/components/general-pages/page-not-found/page-not-found.component').then(
                        r => r.PageNotFoundComponent
                    ),
            },
        ],
    },

    {
        path: '',
        canActivate: [AuthGuard], // Adding the user and group guard here still triggers the infinite reload bug
        children: [
            {
                path: '**',
                canActivate: [userAndGroupGuard({ canAccessWithNoGroups: true })], // the guard also acts as a redirect
                loadComponent: () =>
                    import('./shared/components/general-pages/page-not-found/page-not-found.component').then(
                        r => r.PageNotFoundComponent
                    ),
            },
        ],
    },
];
